import CONFIG from '../../config';

const actions = {
  home(context) {
    context.commit('ADD_LOG', { request: 'home' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('home'), {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'home' });
          resolve(response.data);
          context.commit('SAVE_DATA', response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'home' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  offers(context, params) {
    context.commit('ADD_LOG', { request: 'offers' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('offers'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'offers' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'offers' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  onboardingMarketplace(context) {
    context.commit('ADD_LOG', { request: 'onboardingMarketplace' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('onboardingMarketplace'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'onboardingMarketplace' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'onboardingMarketplace' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  supplierTransactionDetails(context, params) {
    context.commit('ADD_LOG', { request: 'supplierTransactionDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('supplierTransactionDetails'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'supplierTransactionDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'supplierTransactionDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerBlockedTransactions(context, params) {
    context.commit('ADD_LOG', { request: 'customerBlockedTransactions' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('customerBlockedTransactions', params.marketplaceId), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerBlockedTransactions' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerBlockedTransactions' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerPaymentLink(context, params) {
    context.commit('ADD_LOG', { request: 'customerPaymentLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('customerPaymentLink'), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerPaymentLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerPaymentLink' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationMerchantOnboardingLink(context, params) {
    context.commit('ADD_LOG', { request: 'applicationMerchantOnboardingLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('applicationMerchantOnboardingLink'), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMerchantOnboardingLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMerchantOnboardingLink' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerDeliveryUpdate(context, params) {
    context.commit('ADD_LOG', { request: 'customerDeliveryUpdate' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('customerDeliveryUpdate', params.transactionId, params.marketplaceId), params.patchParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerDeliveryUpdate' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerDeliveryUpdate' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerReferralLink(context) {
    context.commit('ADD_LOG', { request: 'customerReferralLink' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('customerReferralLink'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerReferralLink' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerReferralLink' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  gstinVerificationStatus(context) {
    context.commit('ADD_LOG', { request: 'gstinVerificationStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('gstinVerificationStatus'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'gstinVerificationStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'gstinVerificationStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  consentStatus(context, params) {
    context.commit('ADD_LOG', { request: 'consentStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('consentStatus'), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'consentStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'consentStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getConsentStatus(context) {
    context.commit('ADD_LOG', { request: 'consentStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('consentStatus'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'consentStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'consentStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  initiateReKyc(context) {
    context.commit('ADD_LOG', { request: 'initiateReKyc' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('initiateReKyc'), null, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
            'Content-Type': 'application/json'
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'initiateReKyc' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'initiateReKyc' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  opsNextAction(context, params) {
    context.commit('ADD_LOG', { request: 'opsNextAction' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('opsNextAction', params.applicationId), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'opsNextAction' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'opsNextAction' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applyCoupon(context, params) {
    context.commit('ADD_LOG', { request: 'applyCoupon' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applyCoupon', params.processingFeeId, params.couponCode), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applyCoupon' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applyCoupon' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  processingFeeCouponPayment(context, params) {
    context.commit('ADD_LOG', { request: 'processingFeeCouponPayment' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('processingFeeCouponPayment', params.query.id), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'processingFeeCouponPayment' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'processingFeeCouponPayment' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditLoanSignMethod(context, params) {
    context.commit('ADD_LOG', { request: 'creditLoanSignMethod' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('creditLoanSignMethod', params.loanId), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanSignMethod' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanSignMethod' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditLoanSanctionDocument(context, params) {
      context.commit('ADD_LOG', { request: 'creditLoanSanctionDocument' });
      return new Promise((resolve, reject) => {
        this.axios
          .get(`${CONFIG.getEndpoint('creditLoanSanctionDocument', params.loanId)}`, {
            headers:
            {
              Authorization: localStorage.getItem('token'),
            },
            responseType: 'blob',
          })
          .then((response) => {
            context.commit('REMOVE_LOG', { request: 'creditLoanSanctionDocument' });
            resolve(response.data);
          })
          .catch((err) => {
            context.commit('REMOVE_LOG', { request: 'creditLoanSanctionDocument' });
            context.dispatch('resolveError', { err })
              .catch((resolvedError) => {
                reject(resolvedError);
              });
          });
      });
    },
  aadharEsign(context, params) {
    context.commit('ADD_LOG', { request: 'aadharEsign' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('aadharEsign', params.loanId), {}, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'aadharEsign' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'aadharEsign' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  currentAddress(context, params) {
    context.commit('ADD_LOG', { request: 'currentAddress' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('currentAddress', params.applicationId), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'currentAddress' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'currentAddress' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  aadharAddress(context, params) {
    context.commit('ADD_LOG', { request: 'aadharAddress' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('aadharAddress', params.applicationId), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'aadharAddress' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'aadharAddress' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  guarantorRelationList(context) {
    context.commit('ADD_LOG', { request: 'guarantorRelationList' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('guarantorRelationList'), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorRelationList' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorRelationList' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  guarantorDigiLockerUrl(context, params) {
    context.commit('ADD_LOG', { request: 'guarantorDigiLockerUrl' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('guarantorDigiLockerUrl', params.loanId), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorDigiLockerUrl' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorDigiLockerUrl' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  guarantorDigilockerStatus(context, params) {
    context.commit('ADD_LOG', { request: 'guarantorDigilockerStatus' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('guarantorDigilockerStatus', params.loanId), {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorDigilockerStatus' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorDigilockerStatus' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  guarantorResendOtp(context, params) {
    context.commit('ADD_LOG', { request: 'guarantorResendOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('guarantorResendOtp', params.loanId))
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorResendOtp' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorResendOtp' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  guarantorPersonalDetails(context, params) {
    context.commit('ADD_LOG', { request: 'guarantorPersonalDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('guarantorPersonalDetails', params.loanId), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorPersonalDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorPersonalDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  guarantorPan(context, params) {
    context.commit('ADD_LOG', { request: 'guarantorPan' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('guarantorPan', params.loanId), params.postParams, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'guarantorPan' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'guarantorPan' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  aadharEsignSanction(context, params) {
    context.commit('ADD_LOG', { request: 'aadharEsignSanction' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('aadharEsignSanction', params.loanId), {}, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'aadharEsignSanction' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'aadharEsignSanction' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
